import React from "react"
import { useParams } from "react-router-dom"
import {
    Create,
    usePermissions,
} from "react-admin"
import { useTranslate } from "ra-core"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import { ScheduleForm } from "components/schedule"

function ScheduleCreate(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()
    const translate = useTranslate()
    const { id } = useParams<{ id: string }>()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "objects", icon: <ScheduleIcon/> },
    ]

    return (
        <Create title={translate('resources.schedules.create')} 
            resource={`schedules/entity/object/${id}`} 
            redirect={`/objects/${id}/schedules`}
            actions={<RecordActionsTabs subTabs={subTabs} resourceParent="objects" />} 
        >
            <ScheduleForm newRecord />
        </Create>
    )
}

export default ScheduleCreate